import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Link } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { Toaster } from 'sonner';

import Landing from './pages/Landing.jsx';
import GuestAsk from './pages/GuestAsk.jsx';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import DreamPortal from './pages/DreamPortal';
import Tarot from './pages/Tarot';
import LovePortal from './pages/LovePortal';
import Admin from './pages/Admin';
import Success from './pages/Success';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Terms from './pages/Terms.jsx';
import Privacy from './pages/Privacy.jsx';
import DisclaimerPage from './DisclaimerPage.js';
import ContactPage from './ContactPage.js';

import BackgroundMusic from './components/BackgroundMusic';

import './App.css';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BackgroundMusic />

        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/guest-ask" element={<GuestAsk />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dream-portal" element={<DreamPortal />} />
            <Route path="/tarot" element={<Tarot />} />
            <Route path="/love-portal" element={<LovePortal />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/success" element={<Success />} />

            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/disclaimer" element={<DisclaimerPage />} />
            <Route path="/contact" element={<ContactPage />} />

            <Route path="/index.html" element={<Navigate to="/" replace />} />
          </Routes>

          <div
            style={{
              textAlign: 'center',
              padding: '20px',
              fontSize: '14px',
              opacity: 0.8,
            }}
          >
            <Link to="/terms">Termeni și condiții</Link> |{' '}
            <Link to="/privacy">Confidențialitate</Link> |{' '}
            <Link to="/disclaimer">Declinare a responsabilității</Link> |{' '}
            <Link to="/contact">Contact</Link>
          </div>
        </BrowserRouter>

        <Toaster position="top-center" theme="dark" />
      </div>
    </LanguageProvider>
  );
}

export default App;
